/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import baseGlobal from '@amblique/base/app/theme/foundations/styles';

export default {
  global: {
    ...baseGlobal.global,

    '*': {
      scrollbarColor: '#8C683B #F7F5F0',
      scrollbarWidth: 'thin',
    },

    '.sr-only': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px 0',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
    },

    // Native HTML typography mapping to textStyles
    // h1 => headingXL
    'h1': {
      fontSize: {base: '2rem', lg: '2.5rem'},
      fontWeight: 500,
      lineHeight: 1.2,
      fontFamily: 'heading',
    },
    // h2 => headingL
    'h2': {
      fontSize: {base: '1.5rem', lg: '2rem'},
      fontWeight: 500,
      lineHeight: {base: 1.5, lg: 1.4},
      fontFamily: 'heading',
    },
    // h3 => labelXL
    'h3': {
      fontSize: {base: '1.25rem', lg: '1.5rem'},
      fontWeight: 500,
      lineHeight: {base: 1.5, lg: 1.4},
      fontFamily: 'body',
    },
    // body, p, span => bodyDefault
    'body, p, span': {
      fontSize: {base: '0.875rem', lg: '1rem'},
      fontWeight: 400,
      lineHeight: 1.4,
      fontFamily: 'body',
    },

    // Override .amb-markup styles from vendor with new typography
    '.amb-markup': {
      // h1 => headingXL
      'h1, .h1': {
        fontSize: {base: '2rem', lg: '2.5rem'},
        fontWeight: 500,
        lineHeight: 1.2, // 120%
        fontFamily: 'heading',
        mb: '0.5rem',
      },
      // h2 => headingL
      'h2, .h2': {
        fontSize: {base: '1.5rem', lg: '2rem'},
        fontWeight: 500,
        lineHeight: {base: 1.5, lg: 1.4},
        fontFamily: 'heading',
        mb: '0.5rem',
      },
      // h3 => labelXL
      'h3, .h3': {
        fontSize: {base: '1.25rem', lg: '1.5rem'},
        fontWeight: 500,
        lineHeight: {base: 1.5, lg: 1.4},
        fontFamily: 'body',
        mb: '0.5rem',
      },
      // h4 => labelL
      'h4, .h4': {
        fontSize: {base: '1rem', lg: '1.125rem'},
        fontWeight: 500,
        lineHeight: 1.6,
        fontFamily: 'body',
        mb: '0.5rem',
      },
      // h5 => labelDefault
      'h5, .h5': {
        fontSize: {base: '0.875rem', lg: '1rem'},
        fontWeight: 600,
        lineHeight: 1.4,
        fontFamily: 'body',
        mb: '0.5rem',
      },
      // h6 => labelS
      'h6, .h6': {
        fontSize: {base: '0.8125rem', lg: '0.75rem'},
        fontWeight: 600,
        lineHeight: 1.2,
        fontFamily: 'body',
        mb: '0.5rem',
      },
      // p => bodyDefault
      'p': {
        fontSize: {base: '0.875rem', lg: '1rem'},
        fontWeight: 400,
        lineHeight: 1.4,
        fontFamily: 'body',
        mb: '0.5rem',
      },
      'hr': {
        my: '1rem',
      },
      // blockquote => custom style with left border
      'blockquote': {
        borderLeftWidth: '4px',
        borderLeftStyle: 'solid',
        borderLeftColor: 'primary.darkLinen', // #8C683B
        paddingLeft: {base: '24px', lg: '32px'},
        my: '1rem',
      },
      // p within blockquote inherits blockquote typography
      'blockquote p': {
        fontSize: {base: '1.25rem', lg: '1.75rem'}, // 20px mobile, 28px desktop
        fontWeight: 400,
        lineHeight: {base: 1.5, lg: 1.4},
        fontFamily: 'body',
        mb: 0, // Remove bottom margin for p inside blockquote
      },
      // sup and sub => bodyS
      'sup, sub': {
        fontSize: {base: '0.8125rem', lg: '0.75rem'}, // 13px mobile, 12px desktop
        fontWeight: 400,
        lineHeight: 1.2,
        fontFamily: 'body',
      },
    },
  },
};
